// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Tabs_wrap__39RKj"};